export const sheetFont = (bold: boolean) => {
  return {
    name: "Arial",
    size: 10,
    bold: bold,
  } as { name: string; size: number; bold: boolean };
};
